import useSWR from 'swr';

import { usePrivate } from '@/components/private';
import { enqueueSnackbar } from '@/providers';

import { useGetMembershipsByUserIdMessages } from './messages';

export interface useGetMembershipsByUserIdOptions {
  shouldFetch?: boolean;
}

export function useGetMembershipsByUserId(
  userId: number | null | undefined,
  options?: useGetMembershipsByUserIdOptions,
) {
  const mergedOptions: useGetMembershipsByUserIdOptions = {
    shouldFetch: true,
    ...options,
  };

  const { membershipApi } = usePrivate();

  const results = useSWR(
    membershipApi && mergedOptions.shouldFetch
      ? `/api/Membership/GetMembershipsByUserId/${userId}`
      : null,
    () => membershipApi?.apiMembershipGetMembershipsByUserIdUserIdGet(userId!),
    {
      onError: (error) => {
        enqueueSnackbar(
          useGetMembershipsByUserIdMessages[
            'useGetMembershipsByUserId.fetch.unexpectedError'
          ],
          {
            variant: 'error',
          },
        );
        console.error(
          '[BREEDLOGIC] <useGetMembershipsByUserId> error fetching memberships.',
          error,
        );
      },
    },
  );

  const isLoadingOrValidating =
    results.isLoading || results.isValidating || !membershipApi;

  return { ...results, isLoadingOrValidating };
}
